import styled, { css } from 'styled-components';
import ReactModal, { Props } from 'react-modal';
import { ReactComponent as CrossIcon } from 'src/assets/cross.svg';

export const CloseIcon = styled(CrossIcon)<{ $disabled?: boolean }>`
  position: absolute;
  right: 22px;
  top: 22px;
  cursor: pointer;
  z-index: 1000000;
  fill: ${({ theme }) => theme.colors.prussianBlue};

  &:hover {
    fill: ${({ theme }) => theme.colors.gp1};
  }

  ${({ $disabled, theme }) =>
    $disabled &&
    css`
      fill: ${theme.colors.cflowerBlue};
      cursor: not-allowed;
      pointer-events: none;
      opacity: 0.5;
    `}
`;

export interface ContainerProps {
  $isLoading?: boolean;
  translateX?: number;
}

export const Container = styled(ReactModal).attrs<{ overlayClassName?: Props['overlayClassName'] }>((props) => ({
  shouldCloseOnOverlayClick: true,
  ...props,
}))<ContainerProps>`
  background: ${({ theme }) => theme.colors.white};
  z-index: 1;
  outline: none;
  border-radius: 6px;
  position: relative;
  padding: 40px;
  /* The viewport inset lives on the OVERLAY as padding, not here as margin.
     'margin: 20px' + 'max-height: calc(100vh - 40px)' looked symmetric but is not: the overlay is a
     centring flex container, and a flex item that fills its line cannot be relied on to distribute
     its own margin evenly once it overflows — the modal ended up touching the bottom edge with a
     visible gap left at the top. Overlay padding is honoured on both sides unconditionally and
     cannot be eaten by overflow, so the gap is equal by construction and the modal can never reach
     the screen edge. */
  margin: 0;
  ${({ translateX }) => translateX && `transform: translateX(${translateX}px);`};
  overflow-x: hidden;
  overflow-y: auto;
  max-height: 100%;

  .wizzard {
    position: absolute;
    left: -10px;
    top: 5px;
    /* width: 0; */
  }

  .m-title {
    font-weight: 600;
    color: ${({ theme }) => theme.colors.prussianBlue};
  }

  .h-padding {
    padding: 0 40px;
  }

  .children {
    ${({ $isLoading }) =>
      $isLoading &&
      css`
        * {
          cursor: wait;
        }
        &:after {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          cursor: wait;
          z-index: 1000000;
        }
      `};
  }

  .cydea-select {
    min-width: unset;
  }

  .error {
    text-align: center;
    p,
    span {
      color: ${({ theme }) => theme.colors.error};
    }
  }

  ${({ theme }) => theme.breakpoints.down('md')} {
    padding: 30px;
    .h-padding {
      padding: 0 30px;
    }
  }
  ${({ theme }) => theme.breakpoints.down('sm')} {
    padding: 20px;
    .wizzard {
      display: none;
    }
    .h-padding {
      padding: 0 20px;
    }
  }
`;

export const WandIcon = styled.img`
  transform: scale(0.4);
`;
